import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// 페이지 컴포넌트
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OrderList from './pages/OrderList';
import CreateOrder from './pages/CreateOrder';
//import DriversList from './pages/DriverList';
//import ClientsList from './pages/ClientList';
import LiveTracking from './pages/LiveTracking';
import StaffList from './pages/StaffList';
import BackupPage from './pages/BackupPage';
import Layout from './components/Layout';
import DriverList from './pages/DriverList';
import ClientList from './pages/ClientList';
import CustomerList from './pages/CustomerList';
import TransactionsPage from './pages/TransactionsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import Notifications from './pages/Notifications';
import UserManual from './pages/UserManual';
import Settings from './pages/Settings';
import EventLogsPage from './pages/EventLogsPage';

// Material-UI 테마 설정
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// 관리자 전용 라우트 (manager 이상)
function ManagerRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isManager = user.role === 'super_admin' || user.role === 'admin' || user.role === 'manager';

  if (!isManager) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

// Admin 전용 라우트
function AdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (user.role !== 'super_admin' && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* 공개 페이지 (로그인 불필요) */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/" replace />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />

          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<OrderList />} />
            <Route path="orders/new" element={<CreateOrder />} />
            <Route path="drivers" element={<DriverList />} />
            <Route path="clients" element={<ClientList />} />
            <Route path="customers" element={<CustomerList />} />
            <Route path="transactions" element={<TransactionsPage />} />
            <Route path="tracking" element={<LiveTracking />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="manual" element={<UserManual />} />
            <Route
              path="staff"
              element={
                <ManagerRoute>
                  <StaffList />
                </ManagerRoute>
              }
            />
            <Route
              path="backup"
              element={
                <AdminRoute>
                  <BackupPage />
                </AdminRoute>
              }
            />
            <Route
              path="settings"
              element={
                <AdminRoute>
                  <Settings />
                </AdminRoute>
              }
            />
            <Route
              path="event-logs"
              element={
                <AdminRoute>
                  <EventLogsPage />
                </AdminRoute>
              }
            />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
